export default "__VITE_ASSET__c6myMhWj__"